module.exports = __webpack_public_path__ + "assets/1cab946c33aa4befb4b10a0332defaaa.png";